export const ja = {
  heroData: {
    title: "当日の流れ",
    subtitle: "搭乗当日のスケジュールをご案内します。スムーズな体験のため、事前にご確認ください。",
    image: "https://readdy.ai/api/search-image?query=Helicopter%20on%20helipad%20during%20golden%20hour%20sunset%20with%20warm%20lighting%2C%20pilot%20in%20uniform%20walking%20nearby%2C%20clean%20professional%20aviation%20scene%2C%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=flowhero01&orientation=landscape",
  },
  scheduleData: {
    label: "SCHEDULE",
    title: "当日のスケジュール",
    items: [
      { time: "30分前", title: "ヘリポート到着・受付", desc: "搭乗開始時刻の30分前にヘリポートへご到着ください。受付でご予約の確認と、簡単な安全説明を行います。" },
      { time: "20分前", title: "安全説明", desc: "搭乗前に安全についての説明を行います。ヘリコプターの構造、非常時の対応、機内での注意点をご案内します。" },
      { time: "15分前", title: "記念撮影（オプション）", desc: "機体の前で記念撮影を行います。プロカメラマンによる撮影オプションもございます。" },
      { time: "搭乗時刻", title: "搭乗・離陸", desc: "パイロットの誘導で機体へ。シートベルトを締めたら、エンジンが回り、機体が浮き上がります。地上では見られない絶景が広がります。" },
      { time: "帰着後", title: "帰着・解散", desc: "搭乗後、ヘリポートにて解散となります。記念撮影のデータは後日お送りいたします。" },
    ],
  },
  tipsData: {
    label: "TIPS",
    title: "当日のヒント",
    items: [
      "遅刻されると搭乗をお断りする場合があります。必ず余裕を持ってお越しください",
      "飲酒後の搭乗は、安全上お断りする場合があります",
      "体調不良時は、無理をせずキャンセルをご検討ください",
      "カメラやスマートフォンのバッテリーは事前に充電しておいてください",
      "天候により、当日の欠航判断が行われる場合があります",
    ],
  },
  finalCTA: {
    title: "当日の流れは、\nご予約時にも詳しくご案内いたします",
    subtitle: "ご不明な点があれば、お気軽にお問い合わせください",
    ctas: [
      { label: "予約について問い合わせる", href: "/contact", type: "primary" },
      { label: "初めての方はこちら", href: "/first-time", type: "ghost" },
    ],
  },
};

export const en = {
  heroData: {
    title: "What to Expect on the Day",
    subtitle: "Here is a guide to the day-of schedule. Please review it in advance for a smooth experience.",
    image: "https://readdy.ai/api/search-image?query=Helicopter%20on%20helipad%20during%20golden%20hour%20sunset%20with%20warm%20lighting%2C%20pilot%20in%20uniform%20walking%20nearby%2C%20clean%20professional%20aviation%20scene%2C%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=flowhero01&orientation=landscape",
  },
  scheduleData: {
    label: "SCHEDULE",
    title: "Day-of Schedule",
    items: [
      { time: "30 min before", title: "Arrive at the Helipad & Check In", desc: "Please arrive at the helipad 30 minutes before your scheduled boarding time. At check-in, we will confirm your reservation and conduct a brief safety briefing." },
      { time: "20 min before", title: "Safety Briefing", desc: "Before boarding, you will receive a full safety briefing covering helicopter structure, emergency procedures, and in-cabin guidelines." },
      { time: "15 min before", title: "Commemorative Photo (Optional)", desc: "Take a photo in front of the helicopter. A professional photographer option is also available." },
      { time: "Boarding time", title: "Board & Take Off", desc: "Guided by the pilot, you will board the helicopter. Once your seatbelt is fastened, the engine starts and you lift off — and the breathtaking scenery unfolds before you." },
      { time: "After landing", title: "Return & Farewell", desc: "After landing at the helipad, you are free to go. Commemorative photo data will be sent to you at a later date." },
    ],
  },
  tipsData: {
    label: "TIPS",
    title: "Day-of Tips",
    items: [
      "Late arrivals may not be permitted to board. Please allow plenty of time.",
      "Boarding after consuming alcohol may not be permitted for safety reasons.",
      "If you are feeling unwell, please consider cancelling rather than pushing through.",
      "Make sure your camera and smartphone are fully charged before arrival.",
      "Flights may be cancelled on the day depending on weather conditions.",
    ],
  },
  finalCTA: {
    title: "Full day-of details will\nbe provided at booking",
    subtitle: "Feel free to contact us if you have any questions",
    ctas: [
      { label: "Inquire About Booking", href: "/contact", type: "primary" },
      { label: "First-Time Visitors", href: "/first-time", type: "ghost" },
    ],
  },
};
